import { getHost } from '@booking-portal/composables/get-host';
import { getApiEndpoint } from '@booking-portal/utils/env-utils';

export const defaultFavIconSizes = [32, 128, 180, 192];

export const defaultFavicon = {
  rel: 'icon',
  type: 'image/png',
  href: '/favicon.png',
  sizes: '32x32',
  referrerpolicy: 'origin',
} as const;

export function getFavIcons(
  locationId?: number | null,
  sizes: number[] = defaultFavIconSizes
) {
  const endpoint = getApiEndpoint();
  const host = getHost();
  const favicons: {
    rel: 'icon';
    type: 'image/png';
    href: string;
    sizes: string;
    referrerpolicy: 'origin';
  }[] = [];

  if (!sizes || !sizes.length) {
    favicons.push(defaultFavicon);
    return favicons;
  }

  sizes.forEach((size) => {
    let href = `${endpoint}/favicon/${size}?rel=${host}`;
    if (locationId) {
      href += `&locationIds=${locationId}`;
    }
    if (locationId === undefined) {
      return; // Don't add the favicon if the locationId is undefined
    }
    favicons.push({
      rel: 'icon',
      type: 'image/png',
      href,
      sizes: `${size}x${size}`,
      referrerpolicy: 'origin',
    });
  });

  return favicons;
}

export function getScrollbarWidth() {
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (outer.style as any).msOverflowStyle = 'scrollbar';
  document.body.appendChild(outer);
  const inner = document.createElement('div');
  outer.appendChild(inner);
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
  outer.parentNode?.removeChild(outer);

  return scrollbarWidth;
}

export function isScrollbarVisible() {
  const viewportHeight = window.innerHeight;
  const scrollHeight = document.body.scrollHeight;
  return scrollHeight > viewportHeight;
}
